import classnames from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import type { AbstractMedia } from 'modules/medias/types/abstract-media';
import { getCurrentUserIsReadOnly } from 'modules/users/selectors/currentUser';
import Tooltip from 'ui/base/Tooltip';

import type { MediaListItem } from '../../types';
import { RestrictIcon } from '../UI';

type RestrictProps = {
  disabled?: boolean;
  media: MediaListItem<AbstractMedia>;
  onRestrict: (media: MediaListItem<AbstractMedia>) => void;
};

const Restrict: React.FC<RestrictProps> = ({ media, disabled: disabledProp, onRestrict }) => {
  const intl = useIntl();
  const readonly = useSelector(getCurrentUserIsReadOnly);
  const disabled = readonly || disabledProp;
  const isPublic = !media.data.restricted;

  const dataCy = `advice-media-restrict-${isPublic ? 'public' : 'private'}`;

  const handleRestrict = React.useCallback(() => {
    if (!disabled) {
      onRestrict(media);
    }
  }, [disabled, onRestrict, media]);

  return (
    <Tooltip
      title={intl.formatMessage({
        id: isPublic ? 'page.public' : 'page.private',
        defaultMessage: isPublic ? 'Public' : 'Private'
      })}
    >
      <RestrictIcon
        data-cy={dataCy}
        className={classnames(
          'position-absolute d-flex rounded align-items-center justify-content-center text-white cursor-pointer',
          {
            'fb-icon--eye': isPublic,
            'fb-icon--no-eye private': !isPublic,
            'cursor-not-allowed': disabled
          }
        )}
        onClick={handleRestrict}
      />
    </Tooltip>
  );
};

export default Restrict;
